import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export type BrandLiveCardShape = 'Corner' | 'BottomBar' | 'Vertical';

export interface BrandLiveCardAd {
  logoUrl: string;
  title: string;
  line?: string | null;
  goUrl: string;
}

interface Props {
  ad: BrandLiveCardAd;
  shape: BrandLiveCardShape;
  /** Xem trước trong trang quản lý: không bấm được. */
  preview?: boolean;
}

const OUTLINE = '0 1px 3px rgba(0,0,0,.8)';

const BASE: React.CSSProperties = {
  boxSizing: 'border-box',
  background: 'rgba(17,24,39,.88)',
  color: '#fff',
  borderRadius: 14,
  border: '1px solid rgba(255,255,255,.18)',
  boxShadow: '0 6px 24px rgba(0,0,0,.45)',
  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  overflow: 'hidden',
};

const QR_BG = '#ffffff';

const BrandLiveCard: React.FC<Props> = ({ ad, shape, preview }) => {
  const line = ad.line?.trim();
  const logo = (size: number) =>
    ad.logoUrl ? (
      <img
        src={ad.logoUrl}
        alt=""
        style={{
          width: size,
          height: size,
          borderRadius: 10,
          objectFit: 'cover',
          flexShrink: 0,
          background: '#fff',
        }}
      />
    ) : null;
  const qr = (size: number) => (
    <div
      style={{
        background: QR_BG,
        padding: 4,
        borderRadius: 6,
        lineHeight: 0,
        flexShrink: 0,
      }}
    >
      <QRCodeSVG value={ad.goUrl} size={size} level="M" />
    </div>
  );
  const title = (size: number) => (
    <div
      style={{
        fontSize: size,
        fontWeight: 700,
        lineHeight: 1.2,
        textShadow: OUTLINE,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {ad.title}
    </div>
  );
  const sub = (size: number) =>
    line ? (
      <div
        style={{
          fontSize: size,
          opacity: 0.85,
          lineHeight: 1.3,
          marginTop: 2,
          textShadow: OUTLINE,
        }}
      >
        {line}
      </div>
    ) : null;

  const pos: React.CSSProperties = preview ? { pointerEvents: 'none' } : {};

  if (shape === 'BottomBar') {
    return (
      <div
        style={{
          ...BASE,
          ...pos,
          width: '100%',
          borderRadius: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          padding: '10px 20px',
        }}
      >
        {logo(56)}
        <div style={{ flex: 1, minWidth: 0 }}>
          {title(22)}
          {sub(15)}
        </div>
        {qr(64)}
      </div>
    );
  }

  if (shape === 'Vertical') {
    return (
      <div
        style={{
          ...BASE,
          ...pos,
          width: 180,
          minHeight: 360,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 12,
          padding: 16,
          textAlign: 'center',
        }}
      >
        {logo(96)}
        <div style={{ width: '100%' }}>
          {title(18)}
          {sub(14)}
        </div>
        <div style={{ marginTop: 'auto' }}>{qr(120)}</div>
      </div>
    );
  }

  // Corner
  return (
    <div
      style={{
        ...BASE,
        ...pos,
        width: 240,
        height: 180,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {logo(40)}
        <div style={{ minWidth: 0, flex: 1 }}>{title(16)}</div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 10,
          flex: 1,
          minHeight: 0,
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>{sub(13)}</div>
        {qr(76)}
      </div>
    </div>
  );
};

export default BrandLiveCard;
